import { render, staticRenderFns } from "./DefaultRider.vue?vue&type=template&id=37bcfde3&scoped=true"
import script from "./DefaultRider.vue?vue&type=script&lang=js"
export * from "./DefaultRider.vue?vue&type=script&lang=js"
import style0 from "./DefaultRider.vue?vue&type=style&index=0&id=37bcfde3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bcfde3",
  null
  
)

export default component.exports